import { CookieLayerData } from "./types";

export const getCookieLayerData = async (
    locale: string
): Promise<CookieLayerData> => {
    switch (locale.replace("_", "-").toLowerCase()) {
        case "bg-bg":
        case "bg":
            return await import("../data/i18n/prod/bg-BG.json");
        case "cs-cz":
        case "cs":
            return await import("../data/i18n/prod/cs-CZ.json");
        case "de-at":
            return await import("../data/i18n/prod/de-AT.json");
        case "de-ch":
            return await import("../data/i18n/prod/de-CH.json");
        case "de-de":
            return await import("../data/i18n/prod/de-DE.json");
        case "de":
        case "de-int":
            return await import("../data/i18n/prod/de-INT.json");
        case "en-ca":
            return await import("../data/i18n/prod/en-CA.json");
        case "en-cn":
            return await import("../data/i18n/prod/en-CN.json");
        case "en-gb":
            return await import("../data/i18n/prod/en-GB.json");
        case "en-sg":
            return await import("../data/i18n/prod/en-SG.json");
        case "en-us":
            return await import("../data/i18n/prod/en-US.json");
        case "en-int":
        case "en":
            return await import("../data/i18n/prod/en-INT.json");
        case "es-es":
            return await import("../data/i18n/prod/es-ES.json");
        case "es-mx":
            return await import("../data/i18n/prod/es-MX.json");
        case "es-int":
        case "es":
            return await import("../data/i18n/prod/es-INT.json");
        case "fr-fr":
            return await import("../data/i18n/prod/fr-FR.json");
        case "fr-ch":
            return await import("../data/i18n/prod/fr-CH.json");
        case "fr-int":
        case "fr":
            return await import("../data/i18n/prod/fr-INT.json");
        case "hu-hu":
        case "hu":
            return await import("../data/i18n/prod/hu-HU.json");
        case "it-it":
        case "it":
            return await import("../data/i18n/prod/it-IT.json");
        case "ja-jp":
        case "ja":
            return await import("../data/i18n/prod/ja-JP.json");
        case "ko-kr":
        case "ko":
            return await import("../data/i18n/prod/ko-KR.json");
        case "nl-nl":
        case "nl":
            return await import("../data/i18n/prod/nl-NL.json");
        case "pl-pl":
        case "pl":
            return await import("../data/i18n/prod/pl-PL.json");
        case "pt-br":
            return await import("../data/i18n/prod/pt-BR.json");
        case "pt-pt":
        case "pt":
            return await import("../data/i18n/prod/pt-PT.json");
        case "ro-ro":
        case "ro":
            return await import("../data/i18n/prod/ro-RO.json");
        case "ru-ru":
            return await import("../data/i18n/prod/ru-RU.json");
        case "ru-int":
        case "ru":
            return await import("../data/i18n/prod/ru-INT.json");
        case "sk-sk":
        case "sk":
            return await import("../data/i18n/prod/sk-SK.json");
        case "sv-se":
        case "sv":
            return await import("../data/i18n/prod/sv-SE.json");
        case "th-th":
        case "th":
            return await import("../data/i18n/prod/th-TH.json");
        case "tr-tr":
        case "tr":
            return await import("../data/i18n/prod/tr-TR.json");
        case "vi-vn":
        case "vi":
            return await import("../data/i18n/prod/vi-VN.json");
        case "zh-cn":
            return await import("../data/i18n/prod/zh-CN.json");
        case "zh-tw":
            return await import("../data/i18n/prod/zh-TW.json");
        case "zh-int":
        case "zh":
            return await import("../data/i18n/prod/zh-INT.json");
        default:
            return await import("../data/i18n/prod/en-INT.json");
    }
};

export default getCookieLayerData;
